var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div class=\"articles-feed-item is-center-aligned\">No results." + (jade.escape(null == (jade_interp = ' ') ? "" : jade_interp)) + "<a href=\"/articles\" class=\"faux-underline\">View all articles</a></div>");;return buf.join("");
};
module.exports = template;